import styled from "@emotion/styled";
import theme from "../../theme";
import { memo, ReactNode } from "react";

const { md } = theme.screen;

type Prop = {
  text: string;
  isRequired?: boolean;
  htmlFor?: string;
  children?: ReactNode;
};

export const Label = memo(
  ({ text, isRequired, htmlFor, children }: Prop) => {
    return (
      <CustomLabel htmlFor={htmlFor}>
        {text}
        {isRequired && <RequiredMark>*</RequiredMark>}
        {children}
      </CustomLabel>
    );
  }
);

const CustomLabel = styled.label`
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  color: ${theme.color.neutral_500};
  margin-bottom: 5px;

  @media (max-width: ${md}px) {
    font-size: ${theme.fontSize.FONT_2};
  }
`;

const RequiredMark = styled.span`
  color: ${theme.color.red_500};
  padding-left: 5px;
`;
